import './quick-filter-guide.scss'
import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class QuickFilterGuide {
    /**
        * Class constructor *
        * @arg {object} - `quickGuideEl` check for the
        * featured Collections slider element.
    **/
    constructor (quickGuideEl) {
        if (!quickGuideEl) return;
        this.quickGuideEl = quickGuideEl;
        this.viewResultsBtn = this.quickGuideEl.querySelector('.js-quick-filter-update-results');
        this.sliderElement = this.quickGuideEl.querySelector('.js-quick-filter-guide-slider');
        this.slides = this.sliderElement.querySelectorAll('.js-slide');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.pagination = this.sliderElement.querySelector('.swiper-pagination');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        
        this.addEventListeners();
        this.initRangeInputs();
        this.filterProducts(true);
        this.initSlider();
    }

    addEventListeners () {
        this.viewResultsBtn.addEventListener('click', () => {
            this.filterProducts();
        })
    }

    initRangeInputs () {
        const rangeSliders = document.querySelectorAll('.js-quick-filter-range');
        rangeSliders.forEach((rangeSlider) => {
            const rangeSliderInput = rangeSlider.querySelector('.js-quick-filter-input');
            const min = rangeSliderInput.min;
            const max = rangeSliderInput.max;
            const valueText = rangeSlider.querySelector('.js-quick-filter-range-value');
            const valueTextInner = rangeSlider.querySelector('.js-quick-filter-range-value-no');
            let value = rangeSliderInput.value;
            const self = this;
            
            valueTextInner.innerHTML = value;
            valueText.style.left = `${(value - min)/(max - min) * 100}%`;
            rangeSliderInput.style.background = `linear-gradient(to right, #D2D2D2 0%, #D2D2D2 ${(value - min) / (max - min) * 100}%, #393939 ${(value - min) / (max - min) * 100}%, #393939 100%)`;

            rangeSliderInput.addEventListener('input', () => {
                self.viewResultsBtn.disabled = false;
                value = rangeSliderInput.value;
                valueTextInner.innerHTML = value;
                valueText.style.left = `${(value - min) / (max - min) * 100}%`;
                rangeSliderInput.style.background = `linear-gradient(to right, #D2D2D2 0%, #D2D2D2 ${(value - min) / (max - min) * 100}%, #393939 ${(value - min) / (max - min) * 100}%, #393939 100%)`
            })
        })
    }

    filterProducts (isLoad) {
        let productsCount = 0;
        const ageValue = parseFloat(this.quickGuideEl.querySelector('#range-age').value);
        const weightValue = parseFloat(this.quickGuideEl.querySelector('#range-weight').value);
        const heightValue = parseFloat(this.quickGuideEl.querySelector('#range-height').value);
        const noResultsText = this.quickGuideEl.querySelector('.js-quick-filter-guide-no-results');
        const sliderControls = this.quickGuideEl.querySelector('.js-quick-filter-guide-slider-controls');

        // Disable button until sliders changed
        if (!isLoad) {
            this.viewResultsBtn.disabled = true;
            // Scroll to results on mobile
            if (window.innerWidth < 1024) {
                document.getElementById('quick-filter-products').scrollIntoView();
            }
        }

        // Hide/Show product slides
        this.slides.forEach(slide => {
            if (parseFloat(slide.dataset.ageMin) < ageValue && ageValue < parseFloat(slide.dataset.ageMax)
                && parseFloat(slide.dataset.weightMin) < weightValue && weightValue < parseFloat(slide.dataset.weightMax)
                && parseFloat(slide.dataset.heightMin) < heightValue && heightValue < parseFloat(slide.dataset.heightMax)
            ) {
                slide.classList.remove('!hidden')
                productsCount += 1
            } else {
                slide.classList.add('!hidden')
            }
        })
        
        // Change product count
        this.quickGuideEl.querySelector('.js-quick-filter-count').innerHTML = productsCount;

        // Show no results text if product count is 0
        if (productsCount == 0) {
            noResultsText.classList.remove('hidden');
        } else {
            if (!noResultsText.classList.contains('hidden')) {
                noResultsText.classList.add('hidden');
            }
        }

        if (productsCount < 3) {
            if (!sliderControls.classList.contains('hidden')) {
                sliderControls.classList.add('hidden');
            }
        } else {
            sliderControls.classList.remove('hidden');
        }
    }

    initSlider () {
        new Swiper(this.sliderElement, {
            slidesPerView: 2,
            spaceBetween: 12,
            threshold: 10,
            speed: 400,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.3,
                    spaceBetween: 20
                }
            }
        });
    }
}
